<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'DakejianLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '大课间推广单位及个人'
            },
            {
              key: '2',
              title: '优秀参与奖'
            },
            {
              key: '3',
              title: '优秀参与人员'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/sai/DakejianList':
                return '1'
              case '/sai/DakejianMemberList':
                return '2'
              case '/sai/DakejianGoodMemberList':
                return '3'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/sai/DakejianList')
                break
              case '2':
                this.$router.push('/sai/DakejianMemberList')
                break
              case '3':
                this.$router.push('/sai/DakejianGoodMemberList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
